import { connect } from 'react-redux';
import VideoPaywall from '@/components/Paywalls/Video';
import { paywallSelector } from '@/selectors';

const mapStateToProps = (state) => {
  return paywallSelector(state);
};
export default connect(mapStateToProps)(VideoPaywall);
